import { DocumentsProcessingCallout } from '../../components/DocumentsProcessingCallout';
import { StepIntro } from '../../components/StepIntro';
import { useManageIntegrationDataContext } from '../../context/manageIntegrationData.context';
import { useIntegrationProviderName } from '../../hooks/useIntegrationProviderName';
import { TrustsBusinessesLinkPane } from './TrustsBusinessesLinkPane';

/** Link existing Luminary trusts and businesses to integration data. */
export function LinkTrustsStep() {
  const { trustsBusinessesLinkForm } = useManageIntegrationDataContext();
  const integrationProviderName = useIntegrationProviderName();

  return (
    <>
      <StepIntro
        title={`Link Luminary entities with ${integrationProviderName} data`}
        subtitle={`Sync ${integrationProviderName} data to Luminary entities, including both trusts and businesses`}
      />
      <DocumentsProcessingCallout />

      <TrustsBusinessesLinkPane
        form={trustsBusinessesLinkForm}
        integrationProviderName={integrationProviderName}
      />
    </>
  );
}
